import regionMap from '../constants/region-map.json';

const regionSetup = (store = '') => {
  const [country] = store.split('-');
  const region = regionMap[country] || 'us-east-1';

  global.SIM_REGION = region;
};

export default regionSetup;